import Vue from "vue"
import Router from "vue-router"
import Home from "@/components/Home"
import Kontakt from "@/components/Kontakt"
import Therapiekosten from "@/components/Therapiekosten"
import UberMich from "@/components/UberMich"
import Vorgehen from "@/components/Vorgehen"
import Problembereiche from "@/components/Problembereiche"
import Impressum from "@/components/Impressum"
import i18n from './i18n'
Vue.use(Router)
let router = new Router({
      mode: "history",
      routes: [
        {
          path: '/',
          redirect: `/${i18n.locale}`
        },
        {
          path: '/:lang',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: "/",
              name: "Home",
              component: Home
            },
            {
              path: "kontakt",
              name: "Kontakt",
              component: Kontakt
            },
            {
              path: "therapiekosten",
              name: "Therapiekosten",
              component: Therapiekosten
            },
            {
              path: "uber-mich",
              name: "UberMich",
              component: UberMich
            },
            {
              path: "vorgehen",
              name: "Vorgehen",
              component: Vorgehen
            },
            {
              path: "problembereiche",
              name: "Problembereiche",
              component: Problembereiche
            },
            {
              path: "impressum",
              name: "Impressum",
              component: Impressum
            }
          ]
          }
        ],
        scrollBehavior() {
          return {
            x: 0,
            y: 0
          }
        }
      });
    export default router;
